/* eslint-disable react/prop-types */
import React from 'react'

// VISUALS
// @ts-expect-error - TODO: Convert to TypeScript
import CirclePack from './Chart/Network/CirclePack'
// @ts-expect-error - TODO: Convert to TypeScript
import PieChart from './Chart/Network/PieChart'
// @ts-expect-error - TODO: Convert to TypeScript
import ReleasePoint from './Chart/ReleasePoint/ReleasePoint'
// @ts-expect-error - TODO: Convert to TypeScript
import Scatter from './Chart/Scatter/Scatter'
// @ts-expect-error - TODO: Convert to TypeScript
import LineGraph from './Chart/Line/LineGraph'
// @ts-expect-error - TODO: Convert to TypeScript
import FieldSVG from './Chart/Helpers/FieldSVG'
// @ts-expect-error - TODO: Convert to TypeScript
import Spray from './Chart/Field/Spray'
// @ts-expect-error - TODO: Convert to TypeScript
import Boxes from './Chart/Field/Boxes'
// @ts-expect-error - TODO: Convert to TypeScript
import FieldContour from './Chart/Field/Contour'
// @ts-expect-error - TODO: Convert to TypeScript
import SprayHexBin from './Chart/Field/HexBin'
// @ts-expect-error - TODO: Convert to TypeScript
import Radial from './Chart/Radial/Radial'
// @ts-expect-error - TODO: Convert to TypeScript
import Sideways from './Chart/Sideways/Sideways'

// @ts-expect-error - TODO: Convert to TypeScript
import ThreeD from './3d/3d'

// LEGENDS
import Legend from './Legend/Legend.tsx'
// @ts-expect-error - TODO: Convert to TypeScript
import HomeRunsLegend from './Legend/HomeRunsLegend'

/// VISUAL HELPERS
// @ts-expect-error - TODO: Convert to TypeScript
import FieldDegreeMarkers from './Chart/Helpers/FieldDegreeMarkers'

import { EVPData, Settings } from './schema/types.ts'
import PitchType from './Chart/Pitch/PitchType.tsx'
import { ChartIndexProvider, useChartOptions } from './Context/ChartContext.tsx'

type ChartProps = {
    chartIndex: number
    settings: Settings
    onPitchClick: (event: React.MouseEvent, pitch: EVPData) => void
}

function ChartContent({
    settings,
    onPitchClick,
}: Omit<ChartProps, 'chartIndex'>) {
    const { chartOptions } = useChartOptions()

    const chartOptionsCurr = chartOptions

    if (chartOptions.chartType === 'pitch') {
        return (
            <PitchType
                chartOptions={chartOptionsCurr}
                settings={settings}
                onPitchClick={onPitchClick}
            />
        )
    }
    if (chartOptions.chartType === 'line') {
        return <LineGraph settings={settings} chartOptions={chartOptionsCurr} />
    }
    if (chartOptions.chartType === 'network') {
        return (
            <>
                {chartOptions.overlayType === 'circlePack' ? (
                    <CirclePack
                        settings={settings}
                        chartOptions={chartOptionsCurr}
                    />
                ) : null}
                {chartOptions.overlayType === 'pie' ? (
                    <PieChart
                        settings={settings}
                        chartOptions={chartOptionsCurr}
                    />
                ) : null}
                <Legend settings={settings} type="pitchName" />
            </>
        )
    }

    if (chartOptions.chartType === 'release') {
        return (
            <ReleasePoint settings={settings} chartOptions={chartOptionsCurr} />
        )
    }

    if (chartOptions.chartType === 'movement') {
        return <Scatter settings={settings} chartOptions={chartOptionsCurr} />
    }

    if (chartOptions.chartType === 'radial') {
        return <Radial settings={settings} chartOptions={chartOptionsCurr} />
    }
    if (chartOptions.chartType === 'sideways') {
        return <Sideways settings={settings} chartOptions={chartOptionsCurr} />
    }
    if (chartOptions.chartType === 'field') {
        return (
            <>
                {chartOptions.showField && (
                    <FieldSVG
                        settings={settings}
                        chartOptions={chartOptionsCurr}
                        venueId={settings.venueId}
                    />
                )}
                {chartOptions.showFieldDegreeMarkers ? (
                    <FieldDegreeMarkers settings={settings} />
                ) : null}
                {chartOptions.overlayType === 'spray' ? (
                    <Spray
                        settings={settings}
                        chartOptions={chartOptionsCurr}
                    />
                ) : null}
                {chartOptions.overlayType === 'contour' ? (
                    <FieldContour
                        settings={settings}
                        chartOptions={chartOptionsCurr}
                    />
                ) : null}
                {chartOptions.overlayType === 'hexbin' ? (
                    <SprayHexBin
                        settings={settings}
                        chartOptions={chartOptionsCurr}
                    />
                ) : null}
                {chartOptions.overlayType === 'boxes' ? (
                    <Boxes
                        settings={settings}
                        chartOptions={chartOptionsCurr}
                    />
                ) : null}
            </>
        )
    }
    if (chartOptions.chartType === '3d') {
        return (() => (
            <>
                <foreignObject
                    width={settings.vizWidth}
                    height={settings.vizHeight}
                >
                    <ThreeD
                        settings={settings}
                        chartOptions={chartOptionsCurr}
                    />
                </foreignObject>
                {chartOptions.overlayType === 'spray' ? (
                    <Legend
                        settings={settings}
                        type={chartOptions.legendType}
                    />
                ) : null}
                {chartOptions.overlayType === 'trajectory' &&
                chartOptions.legend ? (
                    <HomeRunsLegend
                        settings={settings}
                        type={chartOptions.legendType}
                        chartOptions={chartOptionsCurr}
                    />
                ) : null}
            </>
        ))()
    }
}

export default function Chart({
    chartIndex,
    settings,
    onPitchClick,
}: ChartProps) {
    return (
        <ChartIndexProvider index={chartIndex}>
            <ChartContent settings={settings} onPitchClick={onPitchClick} />
        </ChartIndexProvider>
    )
}
